import { eventRequestHandler, EVENTS } from '@edreamsodigeo/frontend-cabin-bags';
const cabinBags = {
  eventRequestHandler,
  EVENTS
};
export default cabinBags;